import React from 'react';
import { HeroBanner, CLPH1 } from './styled';

const isThankYouCards = html => /thank-you-cards-hero/.test(html);
const isFoldedPhotoCards = html => /folded-photo-cards-hero/.test(html);
const isBabyAnnouncement = html => /birth-announcements-hero/.test(html);
const isTableNumbers = html => /wedding-rsvps-hero/.test(html);
const isSerifSuite = html => /simple-serif-suite-hero/.test(html);
const isGeometricSuite = html => /geometric-suite-hero/.test(html);
const isCollaboration = html => /collaboration-cards-hero/.test(html);
const isGathering = html => /gathering-invitations-hero/.test(html);
const isHandLettered = html => /hand-lettered-hero/.test(html);
const isMultiImage = html => /multi-image-hero/.test(html);
const isFoilStamped = html => /foil-stamped-hero/.test(html);
const isWeddingAlbumsHtml = html => /wedding-essentials-hero/.test(html);
const shouldFloatTitle = html =>
  isHoliday2018Card(html) ||
  isThankYouCards(html) ||
  isFoldedPhotoCards(html) ||
  isBabyAnnouncement(html) ||
  isTableNumbers(html) ||
  isGeometricSuite(html) ||
  isSerifSuite(html) ||
  isCollaboration(html) ||
  isGathering(html) ||
  isHandLettered(html) ||
  isMultiImage(html) ||
  isFoilStamped(html) ||
  isWeddingAlbumsHtml(html);
const isHoliday2018Card = html => /holiday-cards-2018-hero/.test(html);
const shouldInvertTitle = html =>
  isThankYouCards(html) ||
  isFoldedPhotoCards(html) ||
  isHandLettered(html) ||
  isMultiImage(html) ||
  isWeddingAlbumsHtml(html);
const shouldCenterTitle = html =>
  isFoldedPhotoCards(html) ||
  isCollaboration(html) ||
  isGathering(html) ||
  isHandLettered(html) ||
  isMultiImage(html) ||
  isFoilStamped(html) ||
  isWeddingAlbumsHtml(html);

export interface StyledH1Props {
  centered?: boolean;
  floating?: boolean;
  inverted?: boolean;
  isHolidayCard?: boolean;
  isSerifSuite?: boolean;
  isInvisibleOnDesktop?: boolean;
  isHoliday2018Card?: boolean;
  hasFilters?: boolean;
}

interface CategoryHeaderProps {
  categoryBanner: string;
  h1: string;
  currentPage: number;
  withStyles?: React.CSSProperties;
  hasFilters?: boolean;
}

export function CategoryHeader(props: CategoryHeaderProps): React.JSX.Element {
  const { categoryBanner, h1, currentPage, withStyles } = props;
  return (
    <>
      <CLPH1
        secondary
        centered={shouldCenterTitle(categoryBanner)}
        floating={shouldFloatTitle(categoryBanner)}
        inverted={shouldInvertTitle(categoryBanner)}
        isSerifSuite={isSerifSuite(categoryBanner)}
        style={{ ...withStyles }}
      >
        {h1} {currentPage && currentPage !== 1 ? ` - Page ${currentPage}` : ''}
      </CLPH1>
      <HeroBanner dangerouslySetInnerHTML={{ __html: categoryBanner }} />
    </>
  );
}
